import { render } from "./OurStats.vue?vue&type=template&id=13c4ab08&scoped=true&ts=true"
import script from "./OurStats.vue?vue&type=script&lang=ts"
export * from "./OurStats.vue?vue&type=script&lang=ts"

import "./OurStats.vue?vue&type=style&index=0&id=13c4ab08&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c4ab08"]])

export default __exports__